module.exports = __webpack_public_path__ + "img/premium-button.8ea71022.jpg";